import { render, staticRenderFns } from "./DetailMessageReceived.vue?vue&type=template&id=389f2bf0&"
import script from "./DetailMessageReceived.vue?vue&type=script&lang=js&"
export * from "./DetailMessageReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports